/* Tempo Kicks — EU / US M / US W / UK size switcher with per-brand conversion tables.
   Display-only: variants stay stored in EU, labels are converted client-side.
   Brand is read from window.tempoVendor (set in layout/theme.liquid), falling back to the page title. */
(function () {
  'use strict';

  // EU -> US Men, per brand (official brand charts). Women = Men + offset (per brand).
  var NIKE = {'35.5':'3.5','36':'4','36.5':'4.5','37.5':'5','38':'5.5','38.5':'6','39':'6.5','40':'7','40.5':'7.5','41':'8','42':'8.5','42.5':'9','43':'9.5','44':'10','44.5':'10.5','45':'11','45.5':'11.5','46':'12','47':'12.5','47.5':'13','48.5':'14','49.5':'15'};
  var ADIDAS = {'35.5':'3.5','36':'4','36 2/3':'4.5','37 1/3':'5','38':'5.5','38 2/3':'6','39 1/3':'6.5','40':'7','40 2/3':'7.5','41 1/3':'8','42':'8.5','42 2/3':'9','43 1/3':'9.5','44':'10','44 2/3':'10.5','45 1/3':'11','46':'11.5','46 2/3':'12','47 1/3':'12.5','48':'13','48 2/3':'13.5','49 1/3':'14','50':'14.5','50 2/3':'15'};
  var ASICS = {'35.5':'3.5','36':'4','37':'4.5','37.5':'5','38':'5.5','39':'6','39.5':'6.5','40':'7','40.5':'7.5','41.5':'8','42':'8.5','42.5':'9','43.5':'9.5','44':'10','44.5':'10.5','45':'11','46':'11.5','46.5':'12','47':'12.5','48':'13','49':'14','50':'15'};
  var NEWBALANCE = {'35.5':'3.5','36':'4','36.5':'4.5','37':'5','37.5':'5.5','38':'6','38.5':'6.5','39.5':'7','40':'7.5','40.5':'8','41.5':'8.5','42':'9','42.5':'9.5','43':'10','44':'10.5','44.5':'11','45':'11.5','45.5':'12','46.5':'12.5','47':'13','47.5':'13.5','49':'14','50':'15'};
  var HOKA = {'36':'4','36 2/3':'4.5','37 1/3':'5','38':'5.5','38 2/3':'6','39 1/3':'6.5','40':'7','40 2/3':'7.5','41 1/3':'8','42':'8.5','42 2/3':'9','43 1/3':'9.5','44':'10','44 2/3':'10.5','45 1/3':'11','46':'11.5','46 2/3':'12','47 1/3':'12.5','48':'13','48 2/3':'13.5','49 1/3':'14'};
  var SALOMON = {'36':'4','36 2/3':'4.5','37 1/3':'5','38':'5.5','38 2/3':'6','39 1/3':'6.5','40':'7','40 2/3':'7.5','41 1/3':'8','42':'8.5','42 2/3':'9','43 1/3':'9.5','44':'10','44 2/3':'10.5','45 1/3':'11','46':'11.5','46 2/3':'12','47 1/3':'12.5','48':'13','48 2/3':'13.5','49 1/3':'14'};
  var BROOKS = {'35.5':'3.5','36':'4','36.5':'4.5','37.5':'5','38':'5.5','38.5':'6','39':'6.5','40':'7','40.5':'7.5','41':'8','42':'8.5','42.5':'9','43':'9.5','44':'10','44.5':'10.5','45':'11','45.5':'11.5','46':'12','46.5':'12.5','47.5':'13','48.5':'14','49.5':'15'};
  var SAUCONY = {'35.5':'3.5','36':'4','37':'4.5','37.5':'5','38':'5.5','38.5':'6','39':'6.5','40':'7','40.5':'7.5','41':'8','42':'8.5','42.5':'9','43':'9.5','44':'10','44.5':'10.5','45':'11','46':'11.5','46.5':'12','47':'12.5','48':'13','49':'14','50':'15'};
  var ON = {'36':'3.5','36.5':'4','37':'4.5','37.5':'5','38':'5.5','38.5':'6','39':'6.5','40':'7','40.5':'7.5','41':'8','42':'8.5','42.5':'9','43':'9.5','44':'10','44.5':'10.5','45':'11','46':'11.5','46.5':'12','47':'12.5','47.5':'13','48':'13.5','49':'14','50':'15'};
  var PUMA = {'35.5':'3','36':'3.5','36.5':'4','37':'4.5','37.5':'5','38':'5.5','38.5':'6','39':'6.5','40':'7','40.5':'7.5','41':'8','42':'8.5','42.5':'9','43':'9.5','44':'10','44.5':'10.5','45':'11','46':'11.5','46.5':'12','47':'12.5','47.5':'13','48.5':'14','49.5':'15'};

  // vendor keyword -> [table, women offset, UK offset] (Women = US Men + offset, UK = US Men + offset)
  var BRANDS = [
    [/jordan|nike|off-white|off white/i, NIKE, 1.5, -1],
    [/yeezy|adidas/i, ADIDAS, 1, -0.5],
    [/asics/i, ASICS, 1.5, -1],
    [/new balance/i, NEWBALANCE, 1.5, -0.5],
    [/hoka/i, HOKA, 1, -0.5],
    [/salomon/i, SALOMON, 1, -0.5],
    [/brooks/i, BROOKS, 1.5, -1],
    [/saucony/i, SAUCONY, 1.5, -1],
    [/\bon\b|on running/i, ON, 1.5, -0.5],
    [/puma/i, PUMA, 1.5, -1]
  ];

  var SIZE_NAMES = ['size', 'taille', 'pointure', 'talla'];
  var FR = /^fr/i.test(document.documentElement.lang || '');
  var ES = /^es/i.test(document.documentElement.lang || '');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (FR ? '/fr/' : ES ? '/es/' : '/');
  var T = FR ? {
    sizeGuide: 'Guide des tailles', close: 'Fermer', loading: 'Chargement…',
    loadError: 'Impossible de charger le guide des tailles.', openPage: 'Ouvrir la page',
    fitNote: '<strong>Conseil de taille :</strong> ce modèle taille petit — nous vous conseillons de prendre 2 à 3 pointures au-dessus de votre pointure habituelle.',
    prop: 'Votre pointure'
  } : ES ? {
    sizeGuide: 'Guía de tallas', close: 'Cerrar', loading: 'Cargando…',
    loadError: 'No se pudo cargar la guía de tallas.', openPage: 'Abrir la página',
    fitNote: '<strong>Consejo de talla:</strong> este modelo talla pequeño — te recomendamos coger 2 o 3 tallas más que tu talla habitual.',
    prop: 'Tu talla'
  } : {
    sizeGuide: 'Size guide', close: 'Close', loading: 'Loading…',
    loadError: 'Could not load the size guide.', openPage: 'Open the page',
    fitNote: '<strong>Sizing tip:</strong> this model runs small — we recommend choosing 2 to 3 sizes above your usual size.',
    prop: 'Your size'
  };
  var STORAGE_KEY = 'tempo-size-unit';

  function num(s) { return parseFloat(String(s).replace(',', '.')); }

  function isEuSize(v) {
    v = String(v).trim();
    if (/^\d{2}(\.\d)?$/.test(v)) { var n = num(v); return n >= 35 && n <= 51; }
    return /^\d{2}\s+[12]\/3$/.test(v);
  }

  function brandInfo() {
    var v = (window.tempoVendor || '') + ' ' + (window.tempoProductTitle || '') + ' ' + (document.title || '');
    for (var i = 0; i < BRANDS.length; i++) {
      if (BRANDS[i][0].test(v)) return BRANDS[i];
    }
    return [null, NIKE, 1.5, -1];
  }

  function convert(eu, unit, info) {
    eu = String(eu).trim();
    if (unit === 'eu') return eu;
    var table = info[1];
    var m = table[eu];
    if (m == null) {
      // fallback: nearest EU key in the table
      var n = num(eu), best = null, bestD = 99;
      for (var k in table) { var d = Math.abs(num(k.replace(' 1/3', '.33').replace(' 2/3', '.67')) - n); if (d < bestD) { bestD = d; best = k; } }
      if (best == null || bestD > 0.6) return eu;
      m = table[best];
    }
    if (unit === 'usm') return m;
    var w = num(m) + (unit === 'uk' ? info[3] : info[2]);
    if (unit === 'uk' && info[1] === NIKE && num(m) < 7) w += 0.5; // Nike chart: below US 7 the UK size is only half a size down
    return (w % 1 === 0 ? String(w) : w.toFixed(1));
  }

  // Default unit: US sizes for customers shopping from the US (or Canada), UK sizes for the UK (and Ireland), EU everywhere else.
  var US_COUNTRIES = ['US', 'CA'];
  var UK_COUNTRIES = ['GB', 'IE'];
  function defaultUnit() {
    var c = (window.tempoCountry || (window.Shopify && window.Shopify.country) || '').toUpperCase();
    if (US_COUNTRIES.indexOf(c) !== -1) return 'usm';
    if (UK_COUNTRIES.indexOf(c) !== -1) return 'uk';
    return 'eu';
  }
  function getUnit() {
    try { return localStorage.getItem(STORAGE_KEY) || defaultUnit(); } catch (e) { return defaultUnit(); }
  }
  function setUnit(u) {
    try { localStorage.setItem(STORAGE_KEY, u); } catch (e) { /* noop */ }
  }

  function collectTargets(container) {
    var targets = [];
    container.querySelectorAll('.product-form-input[data-option-name]').forEach(function (fs) {
      var name = (fs.getAttribute('data-option-name') || '').toLowerCase();
      if (SIZE_NAMES.indexOf(name) === -1) return;
      var nodes = [];
      fs.querySelectorAll('label').forEach(function (lb) {
        var input = document.getElementById(lb.getAttribute('for') || '');
        var euVal = input ? input.value : lb.textContent;
        if (isEuSize(euVal)) nodes.push({ el: lb, eu: String(euVal).trim() });
      });
      if (nodes.length) targets.push({ root: fs, nodes: nodes, legend: fs.querySelector('legend') });
    });
    container.querySelectorAll('.product-form-input-dropdown').forEach(function (div) {
      var label = div.querySelector('label');
      var name = label ? label.textContent.trim().toLowerCase() : '';
      if (SIZE_NAMES.indexOf(name) === -1) return;
      var nodes = [];
      div.querySelectorAll('option').forEach(function (opt) {
        if (isEuSize(opt.value)) nodes.push({ el: opt, eu: String(opt.value).trim() });
      });
      if (nodes.length) targets.push({ root: div, nodes: nodes, legend: label });
    });
    return targets;
  }

  function hasWomenRange(target) {
    return target.nodes.some(function (n) { return num(n.eu) <= 42; });
  }

  function applyUnit(target, unit) {
    var info = brandInfo();
    if (unit === 'usw' && !hasWomenRange(target)) unit = 'usm';
    target.nodes.forEach(function (n) {
      var txt = convert(n.eu, unit, info);
      if (n.el.tagName === 'OPTION') {
        var soldOut = /épuis|unavailable|sold out|agotad/i.test(n.el.textContent);
        n.el.textContent = soldOut ? n.el.textContent.replace(/^[^—-]*/, txt + ' ') : txt;
      } else {
        n.el.textContent = txt;
      }
    });
    if (target.tabs) {
      target.tabs.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('active', b.getAttribute('data-unit') === unit);
      });
    }
  }

  function runsSmall() {
    if (!/\/products\//.test(location.pathname)) return false;
    var t = (document.title || '') + ' ' + (window.tempoProductTitle || '');
    var h = document.querySelector('h1');
    if (h) t += ' ' + h.textContent;
    return /yeezy/i.test(t) || /\bmind\b/i.test(t);
  }

  function buildFitNote(target) {
    if (!runsSmall()) return;
    if (target.root.querySelector('.tempo-fit-note')) return;
    var note = document.createElement('div');
    note.className = 'tempo-fit-note';
    note.innerHTML = T.fitNote;
    if (target.tabs && target.tabs.parentNode) {
      target.tabs.parentNode.insertBefore(note, target.tabs.nextSibling);
    } else if (target.legend && target.legend.parentNode) {
      target.legend.parentNode.insertBefore(note, target.legend.nextSibling);
    } else {
      target.root.insertBefore(note, target.root.firstChild);
    }
  }

  // ---- Size guide drawer: slides in from the right (like the cart), content loaded from /pages/size-guide ----
  var sgDrawer = null, sgLoaded = false;
  function buildDrawer() {
    if (sgDrawer) return sgDrawer;
    var overlay = document.createElement('div');
    overlay.className = 'tempo-sg-overlay';
    var panel = document.createElement('aside');
    panel.className = 'tempo-sg-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', T.sizeGuide);
    panel.innerHTML =
      '<div class="tempo-sg-head"><span class="tempo-sg-title">' + T.sizeGuide + '</span>' +
      '<button type="button" class="tempo-sg-close" aria-label="' + T.close + '">&times;</button></div>' +
      '<div class="tempo-sg-body rte"><p class="tempo-sg-loading">' + T.loading + '</p></div>';
    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSizeGuide(); });
    panel.querySelector('.tempo-sg-close').addEventListener('click', closeSizeGuide);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSizeGuide(); });
    sgDrawer = overlay;
    return overlay;
  }
  function loadSizeGuide() {
    if (sgLoaded) return;
    sgLoaded = true;
    fetch(ROOT + 'pages/size-guide').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('#MainContent .rte, #MainContent .page-content, #MainContent');
      var body = sgDrawer.querySelector('.tempo-sg-body');
      body.innerHTML = content ? content.innerHTML : '<p>' + T.loadError + '</p>';
      body.querySelectorAll('h1, style, script').forEach(function (h) { h.remove(); });
    }).catch(function () {
      sgLoaded = false;
      sgDrawer.querySelector('.tempo-sg-body').innerHTML = '<p>' + T.loadError + ' <a href="' + ROOT + 'pages/size-guide">' + T.openPage + '</a>.</p>';
    });
  }
  function openSizeGuide() {
    var d = buildDrawer();
    loadSizeGuide();
    d.classList.add('is-open');
    document.documentElement.classList.add('tempo-sg-lock');
    var c = d.querySelector('.tempo-sg-close');
    if (c) c.focus();
  }
  function closeSizeGuide() {
    if (!sgDrawer) return;
    sgDrawer.classList.remove('is-open');
    document.documentElement.classList.remove('tempo-sg-lock');
  }

  function buildSizeGuide(target) {
    if (!/\/products\//.test(location.pathname)) return;
    if (target.root.querySelector('.tempo-size-guide')) return;
    var a = document.createElement('a');
    a.className = 'tempo-size-guide';
    a.href = ROOT + 'pages/size-guide';
    a.textContent = T.sizeGuide;
    a.addEventListener('click', function (e) { e.preventDefault(); openSizeGuide(); });
    if (target.legend && target.legend.parentNode) {
      target.legend.classList.add('tempo-legend-row');
      target.legend.appendChild(a);
    } else {
      target.root.insertBefore(a, target.root.firstChild);
    }
  }

  function buildTabs(target) {
    if (target.root.querySelector('.tempo-size-units')) return;
    var wrap = document.createElement('div');
    wrap.className = 'tempo-size-units';
    var units = [['eu', 'EU'], ['usm', 'US M']];
    if (hasWomenRange(target)) units.push(['usw', 'US W']);
    units.push(['uk', 'UK']);
    units.forEach(function (u) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-unit', u[0]);
      b.textContent = u[1];
      b.addEventListener('click', function () {
        setUnit(u[0]);
        allTargets.forEach(function (t) { applyUnit(t, u[0]); });
        updateProps();
      });
      wrap.appendChild(b);
    });
    target.root.classList.add('tempo-rounded-sizes');
    target.tabs = wrap;
    if (target.legend && target.legend.parentNode) {
      target.legend.parentNode.insertBefore(wrap, target.legend.nextSibling);
    } else {
      target.root.insertBefore(wrap, target.root.firstChild);
    }
  }

  var allTargets = [];

  // ---- Cart: send "US M yy (EU xx)" / "UK yy (EU xx)" as a line item property so both sizes show in cart, checkout and order ----
  function currentEu(target) {
    var c = target.root.querySelector('input:checked');
    if (c) return String(c.value).trim();
    var sel = target.root.querySelector('select');
    if (sel) return String(sel.value).trim();
    return null;
  }
  function sizeLabel(eu, unit) {
    var info = brandInfo();
    if (unit === 'usw') return 'US W ' + convert(eu, 'usw', info) + ' (EU ' + eu + ')';
    if (unit === 'uk') return 'UK ' + convert(eu, 'uk', info) + ' (EU ' + eu + ')';
    return 'US M ' + convert(eu, 'usm', info) + ' (EU ' + eu + ')';
  }
  function updateProps() {
    var unit = getUnit();
    allTargets.forEach(function (t) {
      if (!document.contains(t.root)) return;
      var eu = currentEu(t);
      if (!eu || !isEuSize(eu)) return;
      var u = unit;
      if (u === 'usw' && !hasWomenRange(t)) u = 'usm';
      var val = sizeLabel(eu, u);
      var scope = t.root.closest('.shopify-section') || t.root.closest('form') || document;
      scope.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
        if (f.classList.contains('installment')) return;
        var inp = f.querySelector('input[name="properties[' + T.prop + ']"]');
        if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'properties[' + T.prop + ']'; f.appendChild(inp); }
        inp.value = val;
      });
    });
  }
  document.addEventListener('change', function () { setTimeout(updateProps, 0); }, true);

  function init(container) {
    var found = collectTargets(container || document);
    found.forEach(function (t) {
      if (allTargets.some(function (o) { return o.root === t.root; })) return;
      allTargets.push(t);
      buildSizeGuide(t);
      buildTabs(t);
      buildFitNote(t);
      applyUnit(t, getUnit());
    });
    updateProps();
  }

  var css = document.createElement('style');
  css.textContent = '.tempo-size-units{display:inline-flex;gap:.4rem;margin:.5rem 0 .8rem;font-size:1.15rem;line-height:1;font-weight:600}' +
    '.tempo-size-units button{appearance:none;background:transparent;border:1px solid currentColor;border-radius:999px;color:inherit;padding:.65em 1.4em;cursor:pointer;font:inherit;letter-spacing:.04em}' +
    '.tempo-size-units button.active{background:#1b1b1b;color:#fff;border-color:#1b1b1b}' +
    '.tempo-rounded-sizes label{border-radius:999px!important}' +
    '.tempo-rounded-sizes input[type=radio]+label{border-radius:999px!important}' +
    '.tempo-rounded-sizes select{border-radius:999px!important;padding-left:1.1em}' +
    '.tempo-fit-note{display:block;margin:.6rem 0 .9rem;padding:.85em 1.15em;background:#fdf0f0;border-left:3px solid #d61f26;border-radius:12px;font-size:1.05rem;line-height:1.45;color:#d61f26;max-width:46em}' +
    '.tempo-fit-note strong{font-weight:700;color:#d61f26}' +
    '.tempo-legend-row{display:flex;align-items:center;justify-content:space-between;gap:1rem;width:100%}' +
    '.tempo-size-guide{font-size:1.4rem;font-weight:600;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer;white-space:nowrap}' +
    '.tempo-size-guide:hover{opacity:.7}' +
    '.tempo-sg-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:9999;opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease}' +
    '.tempo-sg-overlay.is-open{opacity:1;visibility:visible}' +
    '.tempo-sg-panel{position:absolute;top:0;right:0;height:100%;width:min(480px,100%);background:#fff;color:#111;display:flex;flex-direction:column;box-shadow:-8px 0 30px rgba(0,0,0,.18);transform:translateX(100%);transition:transform .3s ease}' +
    '.tempo-sg-overlay.is-open .tempo-sg-panel{transform:translateX(0)}' +
    '.tempo-sg-head{display:flex;align-items:center;justify-content:space-between;padding:1.6rem 2rem;border-bottom:1px solid #e5e5e5}' +
    '.tempo-sg-title{font-size:1.8rem;font-weight:700;letter-spacing:.02em}' +
    '.tempo-sg-close{appearance:none;background:transparent;border:0;font-size:2.8rem;line-height:1;cursor:pointer;padding:0 .2em;color:#111}' +
    '.tempo-sg-close:hover{opacity:.6}' +
    '.tempo-sg-body{padding:1.6rem 2rem 3rem;overflow-y:auto;-webkit-overflow-scrolling:touch;font-size:1.4rem;line-height:1.5}' +
    '.tempo-sg-body h2{font-size:1.6rem;margin:1.6em 0 .6em}' +
    '.tempo-sg-body table{width:100%;border-collapse:collapse;font-size:1.3rem}' +
    '.tempo-sg-body th,.tempo-sg-body td{border:1px solid #e5e5e5;padding:.5em .6em;text-align:center}' +
    '.tempo-sg-body th{background:#f4f4f4;font-weight:700}' +
    'html.tempo-sg-lock,html.tempo-sg-lock body{overflow:hidden}';
  document.head.appendChild(css);

  function boot() { init(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { init(document); break; }
    }
  });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
